import { render, staticRenderFns } from "./SpcmEssayEditor.vue?vue&type=template&id=98a1b256&lang=true"
import script from "./SpcmEssayEditor.vue?vue&type=script&lang=js"
export * from "./SpcmEssayEditor.vue?vue&type=script&lang=js"
import style0 from "./SpcmEssayEditor.vue?vue&type=style&index=0&id=98a1b256&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports